import { SuspiciousTranService } from '@/services/suspicios'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import { Button, Drawer, notification, UploadFile } from 'antd'
import React, { FC, useEffect, useMemo, useState } from 'react'
import { ComplaintDetailEdit } from '../complaint-detail'
import { CombinedAttachmentUpload } from '../upload'
import { TransactionsService } from '@/services/transactions'
import { VerifiedTable } from '../../transactions/manage-transactions/detail/vehicle/vehical-transactions/verified-table'
import style from './style.module.scss'
import { message } from "antd";
import { useSearchParams } from '@modern-js/runtime/router'
import { RefranceTransactionData } from '@/components/global/transaction-details/refrance-transaction'
import { GlobalStore } from '@/stores/global'

type Props = {
  open: boolean
  onClose: () => void
  transactionId: any
  type: "transaction" | "bulk"
  onComplaintCreated?: () => void
  adjustmentType: any
}

type NotificationType = 'success' | 'info' | 'warning' | 'error';

export const ChargebackDetailPage: FC<Props> = (props) => {
  const globalStore = GlobalStore.useContainer()
  const [searchParams] = useSearchParams();
  const [api, contextHolder] = notification.useNotification();
  const bstTransactionId = useMemo(() => {
    let id = !!props?.transactionId.bst_transaction_id ? props?.transactionId.bst_transaction_id : searchParams.get("bst_transaction_id")
    return id
  }, [searchParams.get("bst_transaction_id"), props.transactionId?.adjustment_info])
  const type = searchParams.get("type")


  const openNotification = (type: NotificationType, message: string) => {
    api[type]({
      message: String(type).toUpperCase(),
      description: message,
      placement: "top",
    });
  };
  const [complaintDetail, setComplaintDetail] = useState<any>([]);
  const [form, setForm] = useState<any>([]);
  const [complaintReasonOptions, setComplaintReasonOptions] = useState<
    { label: string; value: string }[]
  >([]);
  const [latestUpdated, setLatestUpdated] = useState<any>(null);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [selectedRow, setSelectedRow] = useState<any>(null);

  const fetchComplaintDetail = async (id: any) => {
    try {

      const { data } = await SuspiciousTranService.getComplaintDetail(bstTransactionId);
      const comp = data.complaints;
      const complaint = comp?.at(-1) || {};
      const isPending = complaint?.status === 'pending';

      const source =
        props.adjustmentType === "adjustment"
          ? globalStore.adjustmentEligibleAmount
          : globalStore.eligibleAmount;

      const eligibleAmount = source?.eligible_amount?.amount;
      const transactionAmount = source?.transaction_amount?.amount;
      const disputeAmount = eligibleAmount !== 0 ? eligibleAmount : transactionAmount;
      setComplaintDetail(comp);

      const baseForm = {
        complaint_id: null,
        complaint_reason: '',
        complaint_description: '',
        dispute_amount: { amount: disputeAmount },
        reason_code: '',
      };

      if (isPending) {
        setForm([{
          ...baseForm,
          complaint_id: complaint.complaint_id,
          complaint_reason: complaint.reason_code?.description || '',
          reason_code: complaint.reason_code?.reason_code || '',
        }]);
      } else {
        setForm([baseForm]);
      }

    } catch (error) {
      console.error(error);
    }
  };

  let pendCheck = !!complaintDetail && complaintDetail.length > 0 && complaintDetail.every((e: any) => e.status == "pending")
  const fetchComplaintReasons = async () => {
    try {
      const type = searchParams.get("type");
      const types = type === "adjustment" ? ["adjustment"] : ["transaction"];
      let id = "non_technical"
      let reasonCodeId = !pendCheck
      ? (complaintDetail?.[0]?.reason_code?.reason_code ?? "")
      : "";
      // let reasonCodeId = !pendCheck && complaintDetail[0]?.reason_code?.reason_code ? complaintDetail[0]?.reason_code?.reason_code : ""
      const { data } = await SuspiciousTranService.getComplaintReasonCode(id, reasonCodeId, types)
      const options = data.data.map((reason: any) => ({
        label: reason.description,
        value: reason.reason_code,
      }));
      setComplaintReasonOptions(options);
    } catch (error) {
      console.error(error);
    }
  };
  const handleChange = (index: number, field: any, value: any) => {
    setForm((prev: any) => {
      const updated = [...prev];

      const updatedItem = {
        ...updated[index],
        [field]: value,
      };

      updated[index] = updatedItem;

      setLatestUpdated(updatedItem);
      return updated;
    });
  };
  const fetchMultipleTranList = async () => {
    try {
      let ids = bstTransactionId
      const payload = {
        page: 1,
        size: 100
      }
      const data = await TransactionsService.getMultipleTransactionList(ids, payload)
      setMultiTranList(data.data?.data)
    } catch (error) {
      console.log(error)
    }
  }
  const [fileList, setFileList] = useState<UploadFile[]>([]);
  const [SelectValue, setSelectValue] = useState('')
  const baseForm = form[0];

  const alwaysSendTranAmount = useMemo(() => {
    if (!!selectedRowKeys.length) {
      return globalStore.eligibleAmount?.transaction_amount.amount
    } else {
      return baseForm?.dispute_amount?.amount
    }

  }, [selectedRowKeys, baseForm])
  const [loader, setLoader] = useState(false)

  const createComplaint = async () => {
    setLoader(true)
    try {
      const transactionID = bstTransactionId;

      if (!form?.length) return;

      if (!baseForm.complaint_description?.trim()) {
        openNotification('error', 'Chargeback Description is required');
        return;
      }

      if (!baseForm.complaint_reason) {
        openNotification('error', 'Chargeback Reason is required');
        return;
      }
      const type = searchParams.get("type");
      const types = type === "adjustment" ? "adjustment" : "transaction";
      let adjustmenttranID = searchParams.get("adjustment_bst_transaction_id")
      const complaintReason =
        !isNaN(Number(baseForm.complaint_reason)) && baseForm.complaint_reason !== ""
          ? Number(baseForm.complaint_reason)
          : baseForm.reason_code;

      const firstItem = {
        transaction_id: type === "adjustment" ? adjustmenttranID : transactionID,
        reason_code: complaintReason,
        dispute_amount: alwaysSendTranAmount,
        complaint_description: baseForm.complaint_description,
        reference_transaction_id: !!selectedRow?.bst_transaction_id ? selectedRow?.bst_transaction_id : null,
        complaint_type: types

      };
      const attachments = fileList
      const bulkItem = {
        transaction_id: type === "adjustment" ? adjustmenttranID : transactionID,
        reason_code: complaintReason,
        dispute_amount: alwaysSendTranAmount,
        complaint_description: baseForm.complaint_description,
        attachments: attachments,
        reference_transaction_id: !!selectedRow?.bst_transaction_id ? selectedRow?.bst_transaction_id : null,
        complaint_type: types
      };

      const otherItems = selectedRowKeys.map((id: any) => ({
        transaction_id: id.transaction_id,
        reason_code: complaintReason,
        dispute_amount: !!id.transaction_amount?.amount ? id.transaction_amount?.amount : alwaysSendTranAmount,
        complaint_description: baseForm.complaint_description,
      }));

      const payload = [firstItem, ...otherItems];
      const payloadBulk = [bulkItem, ...otherItems];

      const sendPay = {
        data: payload,
        attachments,
      };
      const bulkPay = {
        data: payloadBulk
      };
      if (props.type == "bulk") {
        await SuspiciousTranService.createComplaint(bulkPay)
          .then(() => {
            if (!!props.onComplaintCreated) {
              props.onComplaintCreated()
            }
          });
      } else {
        await SuspiciousTranService.createComplaint(sendPay)
          .then(() => {
            if (!!props.onComplaintCreated) {
              props.onComplaintCreated()
            }
          });
      }
      setLoader(false);
      message.success("Chargeback Created Successfully");
      props.onClose();
      fetchComplaintDetail(transactionID);

    } catch (error: any) {
      setLoader(false);

      openNotification(
        'error',
        error.response?.data?.errors
          ?.map((e: any) => e.message)
          .join(', ')
      );
      console.error('Create Chargeback error:', error);
    }
  };


  const [categoryList, setCategoryList] = useState([])
  const fetchAttachmentCategoryList = async (val: any) => {
    try {
      const response = await TransactionsService.getCategoryList(val);
      setCategoryList(response.data?.data);
    } catch (error) {
      console.log("API ERROR:", error);
    }
  };

  const options = categoryList.map((item: any) => ({
    value: item.category_id,
    label: (
      <span>
        {item.category}
        {item.mandatory && <span style={{ color: "red" }}> *</span>}
      </span>
    ),
    mandatory: item.mandatory
  }));


  const [multiTranList, setMultiTranList] = useState([])


  useEffect(() => {
    if (!!bstTransactionId) {

      fetchComplaintDetail(bstTransactionId)
    }
  }, [props.transactionId, searchParams.get("bst_transaction_id")])
  const [hide, setHide] = useState(false);



  const disableCheck = useMemo(() => {
    const originalAmount = globalStore.eligibleAmount?.eligible_amount?.amount
      ?? globalStore.eligibleAmount?.transaction_amount?.amount;
    const changedAmount = form[0]?.dispute_amount?.amount;
    return originalAmount !== changedAmount;
  }, [form, globalStore.eligibleAmount]);

  const complaintReason = useMemo(() => {
    const value = latestUpdated?.complaint_reason;

    if (
      value !== null &&
      value !== undefined &&
      value !== "" &&
      !isNaN(Number(value))
    ) {
      return Number(value);
    }

    return complaintDetail[0]?.reason_code?.reason_code;
  }, [latestUpdated, complaintDetail]);

  useEffect(() => {
    if (!!complaintReason) {
      fetchAttachmentCategoryList(complaintReason)
    }
  }, [complaintReason])

  return (
    <div>
      {contextHolder}
      <Drawer
        open={!!props.open}
        onClose={() => props.onClose()}
        title={
          <div >
            <div>
              {
                props.transactionId?.category == "suspicious" ?
                  " Review Suspicious Transaction"
                  : "Create New Chargeback"
              }

            </div>
            <span style={{ color: "#000000D9", fontSize: 14 }}>
              Transaction :{props.transactionId?.transaction_id}
            </span>
          </div>
        }
        placement="right"
        width={"650px"}
      >

        <div className="">
          {
            complaintDetail[0]?.reason_code?.reason_code !=="3006" ?
<div style={{ padding: "0px 0px 1.5rem" }}>
            {complaintDetail?.length > 0 && complaintDetail.map((ele: any, i: number) => (
              ele.reference_transaction ? (
                <div key={i} style={{ borderBottom: "1px solid #D7D7D7" }}>
                  <div style={{ paddingBottom: "15px" }}>
                    <RefranceTransactionData
                      referenceData={ele.reference_transaction}
                      title={"Reference Transaction Information"}
                    />
                  </div>
                </div>
              ) : null
            ))}
          </div>
          :""
          }

          <div className="">
            {
              !!form && form.length > 0 &&
              (
                <div className="">
                  {
                    form.map((e: any, i: any) => (
                      <div className="">
                        <ComplaintDetailEdit
                          complaintReasonCodeLists={complaintReasonOptions}
                          fetchComplaintReasons={fetchComplaintReasons}
                          handleChange={(field, value) => handleChange(i, field, value)}
                          selected={type == "adjustment" ? globalStore.adjustmentEligibleAmount : globalStore.eligibleAmount}
                          form={form[i]}
                          disable={!!selectedRowKeys.length}
                          reasonCode={baseForm?.complaint_reason}
                          id={props.transactionId?.transaction_id}
                          setSelectedRow={setSelectedRow}
                          pendCheck={pendCheck}
                        />
                        {!pendCheck ?
                          <div className={`${disableCheck ? style.disable : style.active}`} >
                            {!hide ?
                              <span onClick={() => {
                                setHide((prev: any) => !prev)
                                fetchMultipleTranList()
                              }}>Raise Chargebacks for multiple transactions <ExclamationCircleOutlined size={13} /></span>
                              :
                              <span onClick={() => setHide((prev) => !prev)}> View Less Transactions</span>
                            }
                          </div> : ""}

                        {
                          !!hide ?
                            <div style={{ height: "300px", maxHeight: "300px", overflow: "scroll", paddingTop: "10px" }}>
                              <VerifiedTable
                                multiTranList={multiTranList}
                                setSelectedRowKeys={setSelectedRowKeys}
                                selectedRowKeys={selectedRowKeys}
                                id={props.transactionId?.transaction_id}
                                disableCheck={disableCheck}
                              />

                            </div> : <></>
                        }
                        <div className="" >
                          <CombinedAttachmentUpload
                            items={options}
                            onChangeValue={setSelectValue}
                            setFileList={setFileList}
                            fileList={fileList}
                            selectedValue={SelectValue}
                          />

                        </div>
                      </div>

                    ))
                  }
                </div>
              )

            }
            {
              props.transactionId ? (
                <div style={{ paddingTop: "20px" }}>
                  <Button
                    size="large"
                    style={{ background: "#1890FF", color: "#fff" }}
                    onClick={() => {
                      createComplaint()

                    }}
                    loading={loader}
                  >
                    Submit Chargeback
                  </Button>
                </div>
              ) : ""
            }

          </div>
        </div>


      </Drawer>
    </div>
  )
}





